import { get } from 'libs/request';
import urlParams from 'libs/query';

/* eslint-disable @typescript-eslint/indent, indent */
export default (data) => {
    /**
     * data包含了各个页面单独的字段
     * 包括req_id，version_id，goodsIds，app_id，load_times，is_recommend，
     * 其中is_recommend如果不传，默认为1
     */
    /* eslint-disable no-param-reassign */
    /* eslint-disable no-prototype-builtins */
    if (!Object.prototype.hasOwnProperty.call(data, 'is_recommend')) {
        data.is_recommend = 1;
    }
    /* eslint-enable no-param-reassign */
    /* eslint-enable no-prototype-builtins */
    /* eslint-disable one-var */
    const originType = urlParams.origin_type || 0;
    const originId = urlParams.origin_id || 0;
    const newSourceType = urlParams.new_source_type || 0;
    const newSourceId = urlParams.new_source_id || 0;
    const areaType = window.page_type || 0;
    const areaId = window.page_id || 0;
    const sourceType = urlParams.source_type || 0;
    const sourceId = urlParams.source_id || 0;
    const comeFrom = urlParams.come_from;
    // eslint-disable-next-line prettier/prettier
    get(`/log/impression?biz_type=
        ${data.biz_type}&campaign_id=
        ${data.campaign_id}&requestId=
        ${data.req_id}&version_id=
        ${data.version_id}&groupIds=
        ${data.goodsIds}&app_id=
        ${data.app_id}&type=4&come_from=
        ${comeFrom}&load_times=
        ${data.load_times}&origin_type=
        ${originType}&origin_id=
        ${originId}&new_source_type=
        ${newSourceType}&new_source_id=
        ${newSourceId}&area_type=
        ${areaType}&area_id=
        ${areaId}&source_type=
        ${sourceType}&source_id=
        ${sourceId}&is_recommend=
        ${data.is_recommend}`);
};
